export default __webpack_public_path__ + "static/media/A Father's Wrath.6bf72a37.jpg";